// extracted by mini-css-extract-plugin
export var component = "GiftModule-module--component--dLWm3";
export var content = "GiftModule-module--content--lf9+q";
export var title = "GiftModule-module--title--lPHTE";